/* hp26 v4 hero banner system (1 Oct 2026): carousel + "Butcher's picks" stack. No libraries.
   Carousel: autoplay (section setting, default 6s; starts after page load + first visitor activity) that pauses on hover, keyboard focus, hidden tab and the pause button;
   no autoplay under prefers-reduced-motion. Dots, prev/next, Left/Right/Home/End keys, touch/pointer swipe.
   Inactive slides are aria-hidden + inert; a polite live region announces slide changes the visitor makes. */
(function () {
  var rm = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* slide 2+ and banner 4+ images are rendered with data-hp-srcset/data-hp-src (not data-src: the theme's main.js
     copies those on every loading=lazy image) so they don't load with the page */
  function swap(scope) {
    [].slice.call(scope.querySelectorAll('[data-hp-srcset],[data-hp-src]')).forEach(function (el) {
      if (el.dataset.hpSrcset) { el.setAttribute('srcset', el.dataset.hpSrcset); el.removeAttribute('data-hp-srcset'); }
      if (el.dataset.hpSrc) { el.setAttribute('src', el.dataset.hpSrc); el.removeAttribute('data-hp-src'); }
      if (el.tagName === 'IMG') el.loading = 'eager';
    });
  }

  function Carousel(root) {
    var vp = root.querySelector('[data-car-vp]'), track = root.querySelector('[data-car-track]');
    var slides = [].slice.call(root.querySelectorAll('[data-car-slide]'));
    var dots = [].slice.call(root.querySelectorAll('[data-car-dot]'));
    var status = root.querySelector('[data-car-status]'), playBtn = root.querySelector('[data-car-play]');
    var n = slides.length, i = 0, timer = null, interval = Math.max(3, parseFloat(root.dataset.interval) || 6) * 1000;
    if (n < 2) return;
    var userPaused = root.dataset.autoplay === 'false' || rm.matches, hover = false, focus = false, ready = document.readyState === 'complete';

    function warm(k) { swap(slides[(k + n) % n]); }
    function render(announce) {
      track.style.transform = 'translate3d(' + (-100 * i) + '%,0,0)';
      slides.forEach(function (s, k) {
        var on = k === i; s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); s.removeAttribute('inert'); } else { s.setAttribute('aria-hidden', 'true'); s.setAttribute('inert', ''); }
      });
      dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (announce && status) status.textContent = 'Slide ' + (i + 1) + ' of ' + n + ': ' + (slides[i].dataset.label || '');
      warm(i); if (ready) warm(i + 1);
    }
    function go(k, announce) { i = (k + n) % n; render(announce); schedule(); }
    function running() { return ready && !userPaused && !hover && !focus && !document.hidden; }
    function schedule() {
      clearTimeout(timer); timer = null;
      root.classList.toggle('is-paused', userPaused);
      root.dataset.state = running() ? 'playing' : 'paused';
      if (playBtn) playBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
      if (running()) timer = setTimeout(function () { go(i + 1, false); }, interval);
    }

    root.querySelector('[data-car-prev]').addEventListener('click', function () { go(i - 1, true); });
    root.querySelector('[data-car-next]').addEventListener('click', function () { go(i + 1, true); });
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k, true); }); });
    if (playBtn) playBtn.addEventListener('click', function () { userPaused = !userPaused; schedule(); });
    root.addEventListener('keydown', function (e) {
      var k = e.key;
      if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'Home' && k !== 'End') return;
      if (e.target.closest('input,textarea,select')) return;
      e.preventDefault();
      go(k === 'ArrowLeft' ? i - 1 : k === 'ArrowRight' ? i + 1 : k === 'Home' ? 0 : n - 1, true);
      if (e.target.matches('[data-car-dot]') && dots[i]) dots[i].focus();
    });
    root.addEventListener('mouseenter', function () { hover = true; schedule(); });
    root.addEventListener('mouseleave', function () { hover = false; schedule(); });
    root.addEventListener('focusin', function (e) { var fv = true; try { fv = e.target.matches(':focus-visible'); } catch (x) {} if (fv) { focus = true; schedule(); } });
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) { focus = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if (rm.addEventListener) rm.addEventListener('change', function () { if (rm.matches) { userPaused = true; schedule(); } });

    /* swipe (touch, pen or mouse drag) */
    var sx = 0, sy = 0, dx = 0, down = false, drag = false, pid = null, w = 1, block = false;
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      down = true; drag = false; dx = 0; sx = e.clientX; sy = e.clientY; pid = e.pointerId; w = vp.clientWidth || 1; warm(i + 1); warm(i - 1);
    });
    vp.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== pid) return;
      var mx = e.clientX - sx, my = e.clientY - sy;
      if (!drag) {
        if (Math.abs(mx) > 8 && Math.abs(mx) > Math.abs(my)) { drag = true; track.style.transition = 'none'; try { vp.setPointerCapture(pid); } catch (x) {} clearTimeout(timer); }
        else if (Math.abs(my) > 10) { down = false; return; }
        else return;
      }
      dx = mx; var edge = (i === 0 && dx > 0) || (i === n - 1 && dx < 0) ? 0.35 : 1;
      track.style.transform = 'translate3d(' + (-i * w + dx * edge) + 'px,0,0)';
    });
    function end(e) {
      if (!down || (e && e.pointerId !== pid)) return;
      down = false; if (!drag) return;
      drag = false; track.style.transition = ''; block = true; setTimeout(function () { block = false; }, 60);
      var th = Math.min(80, w * 0.18);
      if (dx < -th) go(i + 1, true); else if (dx > th) go(i - 1, true); else go(i, false);
    }
    vp.addEventListener('pointerup', end); vp.addEventListener('pointercancel', end);
    vp.addEventListener('click', function (e) { if (block) { e.preventDefault(); e.stopPropagation(); } }, true);
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });

    /* autoplay and pre-loading the next slide only start once the page has loaded, so they never compete with the LCP image */
    /* The slideshow starts once the page has loaded AND the visitor is active (first scroll, touch, pointer move or key press),
       so a page sitting idle in a background tab or still loading never moves on its own. */
    var loaded = document.readyState === 'complete', active = false;
    function onReady() { if (ready || !loaded || !active) return; ready = true; setTimeout(function () { warm(i + 1); }, 400); schedule(); }
    function onActive() { if (active) return; active = true; ['pointermove', 'pointerdown', 'touchstart', 'scroll', 'wheel', 'keydown'].forEach(function (t) { window.removeEventListener(t, onActive, true); }); onReady(); }
    ['pointermove', 'pointerdown', 'touchstart', 'scroll', 'wheel', 'keydown'].forEach(function (t) { window.addEventListener(t, onActive, { capture: true, passive: true }); });
    ready = false;
    render(false); schedule();
    if (!loaded) window.addEventListener('load', function () { loaded = true; onReady(); }, { once: true });
    root.hp26Carousel = { go: go, index: function () { return i; } };
  }

  function Stack(root) {
    var vp = root.querySelector('[data-bs-vp]'), up = root.querySelector('[data-bs-prev]'), dn = root.querySelector('[data-bs-next]');
    if (!vp) return;
    var swapped = false; function all() { if (!swapped) { swapped = true; swap(vp); } }
    function first() { [].slice.call(vp.children, 0, 3).forEach(swap); } /* 2 visible + the next one */
    /* desktop: the first 3 picks sit beside the hero, so load them now; phones/tablets: the row is at the fold, so wait for page load
       (keeps the bandwidth for the hero/LCP image). Everything else after load. */
    if (window.matchMedia('(min-width:1024px)').matches) first();
    function afterLoad() { first(); setTimeout(all, 1500); }
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
    vp.addEventListener('scroll', all, { passive: true, once: true }); vp.addEventListener('focusin', all, { once: true });
    if (!up || !dn) return;
    function step() { var c = vp.querySelector('.hp26-bn'); return c ? c.getBoundingClientRect().height + 12 : vp.clientHeight / 3; }
    /* v5d: 2 picks visible; the arrows cycle through all of them (wrap at the ends) */
    function upd() {
      var max = vp.scrollHeight - vp.clientHeight;
      up.disabled = dn.disabled = max <= 2;
      var n = vp.children.length, at = Math.round(vp.scrollTop / step());
      root.setAttribute('data-bs-at', String(Math.min(n, at + 1)));
    }
    function by(d) {
      all();
      var max = vp.scrollHeight - vp.clientHeight, b = rm.matches ? 'auto' : 'smooth';
      if (d > 0 && vp.scrollTop >= max - 2) { vp.scrollTo({ top: 0, behavior: b }); return; }
      if (d < 0 && vp.scrollTop <= 2) { vp.scrollTo({ top: max, behavior: b }); return; }
      vp.scrollBy({ top: d * step(), behavior: b });
    }
    up.addEventListener('click', function () { by(-1); });
    dn.addEventListener('click', function () { by(1); });
    vp.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }


  /* v5e/v5f: video card. No src until the page has loaded and the inline video is near the viewport (it is display:none <1024px, so
     phones/tablets never download it), so slide 1 stays the LCP. Autoplays muted on a loop; the only control is a sound on/off toggle
     (unmuting is a user gesture). Pauses while off-screen. prefers-reduced-motion: no autoplay, poster + a "Play video" button.
     <1024px: a round play button next to the pill opens a <dialog> lightbox that plays the clip from the start with sound
     (Esc / close button, focus kept inside and returned, page scroll locked). */
  function pickSrc(v, wantHd) {
    var small = !wantHd && (!window.matchMedia('(min-width:1024px)').matches || (navigator.connection && navigator.connection.saveData));
    return (small ? (v.dataset.srcSd || v.dataset.srcHd) : (v.dataset.srcHd || v.dataset.srcSd)) || v.dataset.src;
  }
  function VideoCard(root) {
    var v = root.querySelector('[data-vc-video]'), snd = root.querySelector('[data-vc-sound]'), tap = root.querySelector('[data-vc-tap]');
    var media = root.querySelector('.hp26-vc__media');
    if (!v) return;
    var loaded = false, visible = false, allowed = !rm.matches;
    function setSnd() {
      if (!snd) return; var on = !v.muted;
      snd.setAttribute('aria-pressed', on ? 'true' : 'false'); snd.setAttribute('aria-label', on ? 'Turn sound off' : 'Turn sound on');
      root.classList.toggle('is-sound', on);
    }
    function load() {
      if (loaded) return; loaded = true;
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      var s = document.createElement('source'); s.src = pickSrc(v, false); s.type = v.dataset.type || 'video/mp4'; v.appendChild(s);
      v.preload = 'auto'; v.load();
      v.addEventListener('playing', function () { root.classList.add('is-playing'); if (tap) tap.hidden = true; });
      v.addEventListener('volumechange', setSnd);
      if (snd) snd.hidden = false;
      setSnd(); play();
    }
    function play() { if (!loaded || !allowed || !visible) return; var pr = v.play(); if (pr && pr.catch) pr.catch(function () { if (tap) tap.hidden = false; }); }
    if (snd) snd.addEventListener('click', function () {
      v.muted = !v.muted; setSnd();
      if (!v.muted && v.paused) { allowed = true; play(); }
    });
    if (tap) {
      if (rm.matches) tap.hidden = false;
      tap.addEventListener('click', function () { allowed = true; visible = true; if (!loaded) load(); else play(); if (snd) snd.focus(); });
    }
    function start() {
      if ('IntersectionObserver' in window && media) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { visible = e.isIntersecting; if (visible) { if (!loaded) { if (allowed) load(); } else play(); } else if (loaded) v.pause(); });
        }, { rootMargin: '200px 0px' }).observe(media);
      } else { visible = true; if (allowed) load(); }
    }
    function afterLoad() { setTimeout(start, 600); }
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });

    /* lightbox */
    var open = root.querySelector('[data-vc-open]'), dlg = root.querySelector('[data-vc-dlg]');
    if (!open || !dlg) return;
    var dv = dlg.querySelector('[data-vd-video]'), x = dlg.querySelector('[data-vd-close]'), back = null, scrollY0 = 0;
    function focusables() { return [].slice.call(dlg.querySelectorAll('button,video[controls],[href],[tabindex]:not([tabindex="-1"])')).filter(function (el) { return !el.hidden; }); }
    function show() {
      back = document.activeElement;
      if (!dv.dataset.ready) { dv.src = pickSrc(v, true); dv.dataset.ready = '1'; }
      try { dv.currentTime = 0; } catch (e) {}
      dv.muted = false; dv.loop = false;
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      scrollY0 = window.scrollY; document.documentElement.classList.add('hp26-noscroll');
      var pr = dv.play(); if (pr && pr.catch) pr.catch(function () {});
      if (!v.paused) v.pause();
      x.focus();
    }
    function hide() {
      dv.pause();
      if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    }
    dlg.addEventListener('close', function () {
      dv.pause(); document.documentElement.classList.remove('hp26-noscroll');
      if (Math.abs(window.scrollY - scrollY0) > 2) window.scrollTo(0, scrollY0);
      if (back && back.focus) back.focus({ preventScroll: true });
      play();
    });
    open.addEventListener('click', show);
    x.addEventListener('click', hide);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); hide(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) hide(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); hide(); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(); if (!f.length) return;
      var i = f.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && (i === f.length - 1 || i < 0)) { e.preventDefault(); f[0].focus(); }
    });
    dv.addEventListener('ended', function () { try { dv.currentTime = 0; } catch (e) {} });
  }

  /* v5e: Butcher's picks row under the hero. Images load after page load / when the row nears the viewport. Prev/next scroll one card
     (wrapping at the ends); Left/Right keys inside the row do the same; swipe + scroll-snap natively. */
  function PicksRow(root) {
    var vp = root.querySelector('[data-pk-vp]'), prev = root.querySelector('[data-pk-prev]'), next = root.querySelector('[data-pk-next]');
    if (!vp) return;
    var done = false; function all() { if (!done) { done = true; swap(vp); } }
    function afterLoad() {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { all(); io.disconnect(); } }, { rootMargin: '400px 0px' });
        io.observe(root);
      } else all();
    }
    if (document.readyState === 'complete') afterLoad(); else window.addEventListener('load', afterLoad, { once: true });
    vp.addEventListener('scroll', all, { passive: true, once: true }); vp.addEventListener('focusin', all, { once: true });
    function step() { var c = vp.querySelector('.hp26-pkc'); if (!c) return vp.clientWidth; var g = parseFloat(getComputedStyle(vp).columnGap) || 0; return c.getBoundingClientRect().width + g; }
    function upd() { var max = vp.scrollWidth - vp.clientWidth; if (prev) prev.disabled = max <= 2; if (next) next.disabled = max <= 2; }
    function by(d) {
      all();
      var max = vp.scrollWidth - vp.clientWidth, b = rm.matches ? 'auto' : 'smooth';
      if (d > 0 && vp.scrollLeft >= max - 2) { vp.scrollTo({ left: 0, behavior: b }); return; }
      if (d < 0 && vp.scrollLeft <= 2) { vp.scrollTo({ left: max, behavior: b }); return; }
      vp.scrollBy({ left: d * step(), behavior: b });
    }
    if (prev) prev.addEventListener('click', function () { by(-1); });
    if (next) next.addEventListener('click', function () { by(1); });
    vp.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var items = [].slice.call(vp.querySelectorAll('.hp26-pkc__a')), i = items.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      var j = e.key === 'ArrowRight' ? (i + 1) % items.length : (i - 1 + items.length) % items.length;
      items[j].focus({ preventScroll: false });
    });
    window.addEventListener('resize', upd); upd();
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-hp26-car]').forEach(function (el) { if (!el.hp26Init) { el.hp26Init = 1; Carousel(el); } });
    (scope || document).querySelectorAll('[data-hp26-bs]').forEach(function (el) { if (!el.hp26Init) { el.hp26Init = 1; Stack(el); } });
    (scope || document).querySelectorAll('[data-hp26-vc]').forEach(function (el) { if (!el.hp26Init) { el.hp26Init = 1; VideoCard(el); } });
    (scope || document).querySelectorAll('[data-hp26-pk]').forEach(function (el) { if (!el.hp26Init) { el.hp26Init = 1; PicksRow(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var s = e.target.closest && e.target.closest('[data-car-slide]'); if (!s) return;
    var car = s.closest('[data-hp26-car]'); if (!car || !car.hp26Carousel) return;
    var list = [].slice.call(car.querySelectorAll('[data-car-slide]')); car.hp26Carousel.go(list.indexOf(s), false);
  });
})();
